<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" :model="filters" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="记录范围">
              <el-select v-model="filters.includeLifted" placeholder="记录范围" class="toolbar-field-w-md">
                <el-option label="仅生效" :value="false"></el-option>
                <el-option label="含已解除" :value="true"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button v-for="item in actionButtonList" :key="item.id || item.Func"
              size="small"
              :type="resolveActionButton(item).type"
              :plain="resolveActionButton(item).plain"
              :icon="resolveActionButton(item).icon"
              :loading="!!item.loading" @click="btnClick(item)">{{ item.name }}</el-button>
          </div>
        </el-form>
      </div>

      <el-alert v-if="DepartmentId && !isClassSelected && classOptions.length"
        title="已选上级节点，可查询下级所有班级禁言；新增时在弹窗中选择班级"
        type="info" show-icon :closable="false" class="tip-alert"></el-alert>
      <el-alert v-else-if="DepartmentId && !classOptions.length"
        title="当前节点下无行政班，请选择学校/校区/年级等有班级的节点"
        type="warning" show-icon :closable="false" class="tip-alert"></el-alert>

            <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
            <div class="tbl-scroll-host">
            <el-table :data="rows" v-loading="listLoading" stripe style="width: 100%;" height="100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="45" align="center"></el-table-column>
        <el-table-column v-if="!isClassSelected" label="班级" min-width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ classLabel(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="学生" min-width="120" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ studentLabel(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="禁发帖" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="banTag(scope.row.banPost != null ? scope.row.banPost : scope.row.BanPost)">
              {{ (scope.row.banPost || scope.row.BanPost) ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="禁评论" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="banTag(scope.row.banComment != null ? scope.row.banComment : scope.row.BanComment)">
              {{ (scope.row.banComment || scope.row.BanComment) ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="原因" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.reason || scope.row.Reason || "—" }}</template>
        </el-table-column>
        <el-table-column label="操作人" width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.operatorName || scope.row.OperatorName || "—" }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="(scope.row.isDeleted || scope.row.IsDeleted) ? 'info' : 'danger'">
              {{ (scope.row.isDeleted || scope.row.IsDeleted) ? "已解除" : "生效中" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="155" align="center">
          <template slot-scope="scope">{{ formatDateTime(scope.row.modifyTime || scope.row.ModifyTime || scope.row.createTime || scope.row.CreateTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="160" align="center" fixed="right">
          <template slot-scope="scope">
            <template v-if="!(scope.row.isDeleted || scope.row.IsDeleted)">
              <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
              <el-button size="mini" type="warning" @click="handleLift(scope.row)">解除</el-button>
            </template>
            <span v-else class="muted-text">—</span>
          </template>
        </el-table-column>
      </el-table>
            </div>

      <div class="pagination-container">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
          :current-page="page" :page-size="pageSize" :total="total"></el-pagination>
      </div>

      <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="480px" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="100px" ref="editForm">
          <el-form-item v-if="dialogMode === 'add' && !isClassSelected" label="班级">
            <el-select v-model="editForm.classId" filterable placeholder="请选择班级" style="width: 100%"
              @change="onDialogClassChange">
              <el-option v-for="c in classOptions" :key="c.id" :label="c.name" :value="c.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学生">
            <el-select v-model="editForm.studentId" filterable placeholder="请选择学生" style="width: 100%"
              :disabled="dialogMode === 'edit'">
              <el-option v-for="s in studentOptions" :key="s.Id" :label="s.Name" :value="s.Id"></el-option>
            </el-select>
            <div class="field-hint">家长端也以学生 Id 标识，禁言按学生维度生效</div>
          </el-form-item>
          <el-form-item label="禁发帖">
            <el-switch v-model="editForm.banPost"></el-switch>
          </el-form-item>
          <el-form-item label="禁评论">
            <el-switch v-model="editForm.banComment"></el-switch>
          </el-form-item>
          <el-form-item label="原因">
            <el-input v-model="editForm.reason" type="textarea" :rows="2" maxlength="200"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitRestriction" :loading="submitLoading">确定</el-button>
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import { getButtonList } from "../../promissionRouter";
import { GetStudentSelectListByClassId } from '../../api/modules/personnel';
import {
  getClassCircleRestrictionPage,
  setClassCircleMemberRestriction,
  onClassCircleDeptChange,
  clearClassCircleListTable,
  resolveClassCircleActionButton,
  pickSingleRow,
  pickMultiRows,
  formatDateTime,
  isClassDeptNode,
  collectClassOptionsFromTreeNode
} from "@/api/classCircle";

/** 禁言目标固定为学生维度（TargetType=1），家长 H5 同样用 stuId */
const RESTRICTION_TARGET_STUDENT = 1;

export default {
  components: { DepartmentPane },
  data() {
    return {
      filters: {
        includeLifted: false
      },
      actionButtonList: [],
      multipleSelection: [],
      rows: [],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      DepartmentId: 0,
      isClassSelected: false,
      classOptions: [],
      classNameMap: {},
      studentOptions: [],
      studentNameMap: {},
      dialogVisible: false,
      dialogTitle: "新增禁言",
      dialogMode: "add",
      submitLoading: false,
      editForm: {
        classId: null,
        studentId: null,
        banPost: true,
        banComment: true,
        reason: ""
      },
      editingClassId: null
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const buttonList = getButtonList(this.$route.path, routers);
    this.actionButtonList = buttonList.filter(b => b.Func !== "handleQuery");
  },
  methods: {
    btnClick(item) {
      if (item.Func && typeof this[item.Func] === "function") {
        this[item.Func](item);
      }
    },
    resolveActionButton(item) {
      return resolveClassCircleActionButton(item);
    },
    formatDateTime,
    banTag(val) {
      return val ? "danger" : "success";
    },
    studentLabel(row) {
      const id = row.studentId != null ? row.studentId : row.StudentId;
      if (!id) return "—";
      const name = this.studentNameMap[id];
      return name ? name + "（" + id + "）" : "ID:" + id;
    },
    classLabel(row) {
      const id = row.departmentId != null ? row.departmentId : row.DepartmentId;
      if (!id) return "—";
      const name = this.classNameMap[id];
      return name || "ID:" + id;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    handleAdd() {
      this.openAdd();
    },
    handleEdit() {
      const row = pickSingleRow(this, "请选择一行禁言记录");
      if (!row) return;
      if (row.isDeleted || row.IsDeleted) {
        this.$message.warning("已解除的记录不可编辑");
        return;
      }
      this.openEdit(row);
    },
    handleDel() {
      const rows = pickMultiRows(this, "请选择要解除的禁言记录");
      if (!rows) return;
      const activeRows = rows.filter(r => !(r.isDeleted || r.IsDeleted));
      if (!activeRows.length) {
        this.$message.warning("所选记录均已解除");
        return;
      }
      this.$confirm("确认解除选中的 " + activeRows.length + " 条禁言？", "解除禁言", { type: "warning" }).then(async () => {
        for (const row of activeRows) {
          const payload = this.buildRestrictionPayload(row, true);
          const res = await setClassCircleMemberRestriction(payload);
          if (!res.data.success) {
            this.$message.error(res.data.msg || "操作失败");
            return;
          }
        }
        this.$message.success("解除成功");
        this.getList();
      }).catch(() => {});
    },
    treeNodeClick(data, node) {
      onClassCircleDeptChange(this, data.value);
      this.isClassSelected = isClassDeptNode(node);
      this.classOptions = collectClassOptionsFromTreeNode(node);
      this.classNameMap = this.classOptions.reduce((map, c) => {
        map[c.id] = c.name;
        return map;
      }, {});
      if (this.isClassSelected) {
        this.loadStudents(this.DepartmentId);
      } else {
        this.studentOptions = [];
      }
      this.handleQuery();
    },
    onDialogClassChange(classId) {
      this.editForm.studentId = null;
      this.loadStudents(classId);
    },
    async loadStudents(classId) {
      if (!classId) {
        this.studentOptions = [];
        return;
      }
      const res = await GetStudentSelectListByClassId({ departmentId: classId });
      this.studentOptions = res.data.success ? (res.data.response || []) : [];
      this.studentOptions.forEach(s => {
        this.studentNameMap[s.Id] = s.Name;
      });
    },
    async enrichStudentNamesFromRows(rows) {
      const deptIds = [];
      const seen = new Set();
      (rows || []).forEach(r => {
        const deptId = r.departmentId != null ? r.departmentId : r.DepartmentId;
        if (deptId && !seen.has(deptId)) {
          seen.add(deptId);
          deptIds.push(deptId);
        }
      });
      await Promise.all(deptIds.map(async deptId => {
        const res = await GetStudentSelectListByClassId({ departmentId: deptId });
        if (res.data.success) {
          (res.data.response || []).forEach(s => {
            this.studentNameMap[s.Id] = s.Name;
          });
        }
      }));
    },
    buildQuery() {
      return {
        departmentId: this.DepartmentId,
        targetType: RESTRICTION_TARGET_STUDENT,
        includeLifted: !!this.filters.includeLifted,
        pageIndex: this.page,
        pageSize: this.pageSize
      };
    },
    buildRestrictionPayload(rowOrForm, lift) {
      const studentId = rowOrForm.studentId != null ? rowOrForm.studentId : rowOrForm.StudentId;
      const departmentId = rowOrForm.classId
        || rowOrForm.departmentId
        || rowOrForm.DepartmentId
        || this.editingClassId
        || this.editForm.classId
        || this.DepartmentId;
      return {
        departmentId,
        targetType: RESTRICTION_TARGET_STUDENT,
        studentId: studentId || 0,
        studentParentId: 0,
        banPost: lift ? false : !!rowOrForm.banPost,
        banComment: lift ? false : !!rowOrForm.banComment,
        reason: lift ? "" : (rowOrForm.reason || ""),
        lift: !!lift
      };
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    async getList() {
      if (!this.DepartmentId) {
        clearClassCircleListTable(this);
        return;
      }
      this.listLoading = true;
      try {
        const res = await getClassCircleRestrictionPage(this.buildQuery());
        if (res.data.success) {
          this.rows = res.data.response.data || [];
          this.total = res.data.response.dataCount || 0;
          if (this.rows.length) {
            await this.enrichStudentNamesFromRows(this.rows);
          }
        } else {
          clearClassCircleListTable(this);
          this.$message.error(res.data.msg || "查询失败");
        }
      } finally {
        this.listLoading = false;
      }
    },
    resetEditForm() {
      this.editForm = {
        classId: this.isClassSelected ? this.DepartmentId : null,
        studentId: null,
        banPost: true,
        banComment: true,
        reason: ""
      };
      this.editingClassId = null;
    },
    openAdd() {
      if (!this.DepartmentId) {
        this.$message.warning("请先在左侧选择机构节点");
        return;
      }
      if (!this.classOptions.length) {
        this.$message.warning("当前节点下无行政班");
        return;
      }
      this.dialogMode = "add";
      this.dialogTitle = "新增禁言";
      this.resetEditForm();
      if (this.editForm.classId) {
        this.loadStudents(this.editForm.classId);
      } else {
        this.studentOptions = [];
      }
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.dialogMode = "edit";
      this.dialogTitle = "编辑禁言";
      const classId = row.departmentId != null ? row.departmentId : row.DepartmentId;
      this.editingClassId = classId;
      this.editForm = {
        classId,
        studentId: row.studentId != null ? row.studentId : row.StudentId,
        banPost: !!(row.banPost != null ? row.banPost : row.BanPost),
        banComment: !!(row.banComment != null ? row.banComment : row.BanComment),
        reason: row.reason || row.Reason || ""
      };
      this.loadStudents(classId);
      this.dialogVisible = true;
    },
    async submitRestriction() {
      const classId = this.dialogMode === "edit"
        ? this.editingClassId
        : this.editForm.classId;
      if (!classId) {
        this.$message.warning("请选择班级");
        return;
      }
      if (!this.editForm.studentId) {
        this.$message.warning("请选择学生");
        return;
      }
      if (!this.editForm.banPost && !this.editForm.banComment) {
        this.$message.warning("至少勾选一项限制");
        return;
      }
      this.submitLoading = true;
      try {
        const payload = this.buildRestrictionPayload({ ...this.editForm, classId }, false);
        const res = await setClassCircleMemberRestriction(payload);
        if (res.data.success) {
          this.$message.success(res.data.msg || "保存成功");
          this.dialogVisible = false;
          this.getList();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      } finally {
        this.submitLoading = false;
      }
    },
    handleLift(row) {
      this.$confirm("确认解除该禁言记录？", "解除禁言", { type: "warning" }).then(async () => {
        const payload = this.buildRestrictionPayload(row, true);
        const res = await setClassCircleMemberRestriction(payload);
        if (res.data.success) {
          this.$message.success(res.data.msg || "解除成功");
          this.getList();
        } else {
          this.$message.error(res.data.msg || "操作失败");
        }
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.tip-alert {
  margin-bottom: 12px;
}
.field-hint {
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
  margin-top: 4px;
}
.pagination-container {
  margin-top: 16px;
  overflow: hidden;
  text-align: right;
}
.muted-text {
  color: #c0c4cc;
}
</style>
